import { defineStore } from 'pinia'
import Cookies from 'js-cookie'

const useAppStore = defineStore(
  'app',
  {
    state: () => ({
      sidebar: {
        opened: Cookies.get('sidebarStatus') ? !!+Cookies.get('sidebarStatus') : true,
        withoutAnimation: false,
      },
      size: Cookies.get('size') || 'default',
      SysDictVOList: []  // 类型字典
    }),
    persist: true,
    actions: {
      toggleSideBar(withoutAnimation) {
        console.log('toggle sidebar',this.sidebar.opened)
        this.sidebar.opened = !this.sidebar.opened
        // this.sidebar.withoutAnimation = withoutAnimation
        if (this.sidebar.opened) {
          Cookies.set('sidebarStatus', 1)
        } else {
          Cookies.set('sidebarStatus', 0)
        }
      },
      closeSideBar({ withoutAnimation }) {
        Cookies.set('sidebarStatus', 0)
        this.sidebar.opened = false
        this.sidebar.withoutAnimation = withoutAnimation
      },
      toggleSideBarHide(status) {
        this.sidebar.hide = status
      },
      setSysDictVOList(list) {
        this.SysDictVOList = list
      },
      getSysDictVOList(key) {
        return new Promise((resolve) => {
          // setTimeout(() => {

            const temp = this.SysDictVOList.find(item => item.dataValue === key);
            console.log(temp,this.SysDictVOList,key);
            resolve(temp.children);
            // return temp.children
          // }, 100);
        });
      },
    }
  })

export default useAppStore
